import { Box, Typography } from '@mui/material'

import { convertToComponent } from '@ecm/data/Contentful'
import { Faq as FaqData } from '@ecm/data/Faq'
import Accordion from '@ecm/ui/element/Accordion'
import Anchor from '@ecm/ui/element/Anchor'
import MainContainer from '@ecm/ui/element/MainContainer'
import FaqJsonLd from '@ecm/ui/seo/FaqJsonLd'

type FaqProps = {
  heading?: string
  showFinePrint?: boolean
  faqs: FaqData[]
  renderJsonLd?: boolean
}

const Faq = ({ heading, faqs, showFinePrint, renderJsonLd = true }: FaqProps) => {
  if (!faqs.length) {
    return null
  }

  return (
    <MainContainer>
      <Box padding={{ md: '4em 0', xs: '2em 0' }} margin="0 auto" maxWidth="lg" width="100%">
        <Typography variant="h3" component="h2" mb="1em">
          {heading ?? 'Frequently asked questions'}
        </Typography>
        {faqs.map((faq, index) => (
          <Accordion key={index} title={faq.question}>
            {convertToComponent(faq.answer)}
          </Accordion>
        ))}
        {renderJsonLd && <FaqJsonLd faq={faqs} />}
        {showFinePrint && (
          <Anchor href="/frequently-asked-questions" fontWeight="400">
            See all Frequently Asked Questions
          </Anchor>
        )}
      </Box>
    </MainContainer>
  )
}

export default Faq
